import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '@/utils';

const useNavigateToHome = () => {
  const navigate = useNavigate();

  return useCallback(() => {
    navigate(AppRoutes.CUSTOMER_FOCUS);
  }, [navigate]);
};

export default useNavigateToHome;
